import CloseIcon from '@/common/assets/icons/closeIcon.svg?react';
import modal from '@/common/components/base/modal/modal.recpie.ts';
import { MainModalProps } from '@/common/components/base/modal/Modal.type.ts';
import Typography from '@/common/components/base/typography/Typography.tsx';
import useIsFirstRender from '@/common/hooks/useIsFirstRender.ts';
import useLockBodyScroll from '@/common/hooks/useLockBodyScroll.ts';
import useRenderWithDelay from '@/common/hooks/useRenderWithDelay.ts';
import { createPortal } from 'react-dom';
import { css, cx } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';

export default function MainModal(props: MainModalProps) {
  const { open } = props;
  const { isRender } = useRenderWithDelay(open, 400);
  return isRender ? <Modal {...props} /> : null;
}
const Modal = ({
  closeModal,
  children,
  open,
  fullHeight,
  childrenWrapperClassName,
  clipOverflow = false,
  height,
  title,
  titleLineColor = '',
  closeOnBackdrop = true,
  closeOnHeaderClick = true,
}: MainModalProps) => {
  const isFirstRender = useIsFirstRender();
  const styles = modal({
    open: !isFirstRender && open,
    fullHeight: fullHeight,
  });

  useLockBodyScroll();

  return createPortal(
    <>
      <Box
        onClick={closeOnBackdrop ? closeModal : undefined}
        className={styles.backdrop}
      />
      <Box
        overflow={clipOverflow ? 'clip' : 'auto'}
        className={cx(styles.modal)}
        height={height}
      >
        <Box mb="1rem" width="100%">
          <Flex
            width="85%"
            mx="auto"
            cursor={closeOnHeaderClick ? 'pointer' : undefined}
            mt="20px"
            justifyContent={!title ? 'end' : 'space-between'}
            onClick={closeOnHeaderClick ? closeModal : undefined}
          >
            <Box display="flex" alignItems="center" gap="8px" mb={32}>
              {!!titleLineColor && (
                <Box
                  width="2.5px"
                  height="16px"
                  borderRadius={50}
                  bgColor={titleLineColor}
                />
              )}
              {!!title && (
                <Typography textStyle={'h2'} color={'black'}>
                  {title}
                </Typography>
              )}
            </Box>
            <Box
              p="12px"
              m="-12px"
              cursor={closeOnHeaderClick ? undefined : 'pointer'}
              onClick={closeOnHeaderClick ? undefined : closeModal}
            >
              <CloseIcon stroke={token('colors.black-3')} />
            </Box>
          </Flex>

          <Box
            className={childrenWrapperClassName ?? css({ width: '85%' })}
            mx="auto"
          >
            {children}
          </Box>
        </Box>
      </Box>
    </>,
    document.body,
  );
};
